<template>
  <div class="one-column-view">
    <div class="article-content">
      <h1>{{ $t("team.title") }}</h1>
      <p>{{ $t("team.description") }}</p>
      <div class="d-flex justify-content-start team-members">
        <div
          v-for="member in teamData"
          class="team-member-card"
          :key="member.id"
          @click="showMember(member)"
        >
          <div class="member-avatar">
            <img :src="member.avatar" :alt="member.name" />
          </div>
          <div class="member-info">
            <h5>{{ member.name }}</h5>
            <p>{{ member.title }}</p>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="team-member"
      ref="team-member"
      :hide-footer="true"
      modal-class="right"
      no-fade
    >
      <div class="member-avatar">
        <img :src="currentMember.avatar" :alt="currentMember.name" />
      </div>
      <h1>{{ currentMember.name }}</h1>
      <h5>{{ currentMember.title }}</h5>
      <ul v-if="currentMember.experiences.length > 1">
        <li v-for="(experience, key) in currentMember.experiences" :key="key">
          {{ experience }}
        </li>
      </ul>
      <p v-else>{{ currentMember.experiences[0] }}</p>
    </b-modal>
  </div>
</template>

<script>
import { BModal } from "bootstrap-vue";
export default {
  components: {
    BModal,
  },
  data() {
    return {
      teamData: [],
      currentMember: {
        id: 1,
        avatar: "/images/team/AliceHansen.png",
        name: "Alice Hansen",
        title: "Chief Executive Officer",
        experiences: [
          "Founder of Golden Link Plus, MWR Int' Inc. and Golden Link Express, Dr. Approved massage chairs.",
          'Years of entrepreneurial experience, including innovative ideas that resulted in large customer increases. Created the American brand massage chair "Relaxology" leading to outstanding sales on Google.',
          "The U.S. - China express shipping business has been successful.",
          "The company markets Philips, a well known medical device in the United States and ResMed respirators from Australia, achieving outstanding results, and becoming the largest supplier in mainland China.",
          "Organized successful yearly international sports competitions, additionally brought big sports sponsors together to further expand the Martial Arts kick boxing universe. Selling out ticket advertising rights, and also selling out advertising management rights for the arenas. Arranged martial arts delegations to visit foreign countries, receiving high levels of engagement and media attention.",
          "The success of each creative business strategy laid the foundation for the following business successes. So launching start-ups with zero capital, and entrepreneurship engagements actively being developed within the United States.",
          "Very high level of focus and engagement upon all business pursuits at both local and international level.",
          "Golden Link+ is a suite of blockchain marketing solutions implemented on the premise of an in-depth understanding of market logic, pain points, brand structure, market dynamics, and targeted business search.",
          "Unique market insights and creative capabilities, in-depth market management experience, 5 years of door to door visits to customers in the United States, more than 15 years of brand marketing sales experience, deeply understanding the market pain.  Founded the innovative GoldenLink+ platform that is in line with market logic.'",
        ],
      },
    };
  },
  mounted() {
    this.getTeamData();
  },
  methods: {
    getTeamData() {
      // 这里应当从API获取数据
      // 通过this.$i18n.locale的值来判断获取相应语言的数据
      //   switch (this.$i18n.locale) {
      //     case 'en':
      //         this.teamData = []
      //         break;
      //     case 'cn':
      //         this.teamData = []
      //         break;
      //     default:
      //         break;
      //   }
      this.teamData = [
        {
          id: 1,
          avatar: "/images/team/AliceHansen.png",
          name: "Alice Hansen",
          title: "Chief Executive Officer",
          experiences: [
            "Founder of Golden Link Plus, MWR Int' Inc. and Golden Link Express, Dr. Approved massage chairs.",
            'Years of entrepreneurial experience, including innovative ideas that resulted in large customer increases. Created the American brand massage chair "Relaxology" leading to outstanding sales on Google.',
            "The U.S. - China express shipping business has been successful.",
            "The company markets Philips, a well known medical device in the United States and ResMed respirators from Australia, achieving outstanding results, and becoming the largest supplier in mainland China.",
            "Organized successful yearly international sports competitions, additionally brought big sports sponsors together to further expand the Martial Arts kick boxing universe. Selling out ticket advertising rights, and also selling out advertising management rights for the arenas. Arranged martial arts delegations to visit foreign countries, receiving high levels of engagement and media attention.",
            "The success of each creative business strategy laid the foundation for the following business successes. So launching start-ups with zero capital, and entrepreneurship engagements actively being developed within the United States.",
            "Very high level of focus and engagement upon all business pursuits at both local and international level.",
            "Golden Link+ is a suite of blockchain marketing solutions implemented on the premise of an in-depth understanding of market logic, pain points, brand structure, market dynamics, and targeted business search.",
            "Unique market insights and creative capabilities, in-depth market management experience, 5 years of door to door visits to customers in the United States, more than 15 years of brand marketing sales experience, deeply understanding the market pain.  Founded the innovative GoldenLink+ platform that is in line with market logic.'",
          ],
        },
        {
          id: 2,
          avatar: "/images/team/JerryPan.png",
          name: "Jerry Pan",
          title: "Chief Technology Officer",
          experiences: ["Spent 22+ years in software development and design. Expert in Geographic Information Systems, digital maps, search, data warehouses, and semantics and has professional experience in IBM and NASA. Jerry has PHD and is a NASA Data Management Project Grant Winner."],
        },
        {
          id: 3,
          avatar: "/images/team/MorrisTulabing.png",
          name: "Morris Tulabing",
          title: "UI/UX Designer",
          experiences: ["Loves building brands. Morris helps people communicate with design. He has more than 15 years in graphic design and UI/UX industry serving clients of different countries."],
        },
        {
          id: 4,
          avatar: "/images/team/JiangHui.png",
          name: "Jiang Hui",
          title: "Technical Manager",
          experiences: ["Served more than 9 years in server-side development at one of the world’s largest retailer - Alibaba. Jiang is a Computer Science graduate."],
        },
        {
          id: 5,
          avatar: "/images/team/VivianYang.png",
          name: "Vivian Yang",
          title: "Product Manager",
          experiences: ["Vivian specializes in E-commerce product management, internet finance. She graduated from communication engineering. She worked in Baofeng Group (Video Entertainment) and JD (largest retailer in China, NASDAQ 100)"],
        },
        {
          id: 6,
          avatar: "/images/team/JinhaiZhao.png",
          name: "Jinhai Zhao",
          title: "Front End Developer",
          experiences: ["7+ years of front-end development and 5+ years of project management experience. He graduated in Computer Science and developed social media apps, games, smart home control. He is also an e-commerce entrepreneur and a consultant."],
        },
        {
          id: 7,
          avatar: "/images/team/JamesSummer.png",
          name: "James Summer",
          title: "Administrative Officer",
          experiences: ["30+ years of Information system development and management at Fortune 50 United Health Group, Mercury Insurance, Wells Fargo, and SoCal Edison, et al Team building/recruiting, executive reporting, and investor relationship management."],
        },
        {
          id: 8,
          avatar: "/images/team/WilsonYe.png",
          name: "Wilson Ye",
          title: "PM",
          experiences: ["Wilson holds a master's degree in computer science, and has more than 10 years experience of software project management and developer services within the Cybersecurity SaaS sector, and has 5 years of experience in blockchain technology, including smart contract audit and SocialFi product development."],
        },
        {
          id: 9,
          avatar: "/images/team/AlexChen.png",
          name: "Alex Chen",
          title: "Marketing Manager",
          experiences: ["Corporate manager of a Chinese multinational company. More than 30 years of practical experience in sales, market development and customer service in large American companies."],
        },
        // {
        //   id: 10,
        //   avatar: "/images/team/WangQuanhai.png",
        //   name: "Wang Quanhai",
        //   title: "Sales Manager",
        //   experiences: ["Vice President of the American Community Development Association Sales Director of a Technology Company Director of an International Trade Company"],
        // },
      ];
    },
    showMember(member) {
      this.currentMember = member;
      this.$refs["team-member"].show();
    },
  },
  watch: {
    "$i18n.locale": function (newVal) {
      // 语言切换后重新获取页面数据
      console.log("locale change", newVal);
      this.getTeamData();
    },
  },
};
</script>

<style>
.team-members {
  flex-wrap: wrap;
  .team-member-card {
    width: 100%;
    padding: 3rem;
    box-sizing: border-box;
    max-height: 400px;
    overflow: hidden;
    border-radius: 1rem;
    position: relative;
    .member-avatar {
      overflow: hidden;
      max-height: 335px;
      border-radius: 1rem;
      img {
        width: 100%;
        margin: 0;
      }
    }
    .member-info {
      width: calc(100% - 6rem);
      position: absolute;
      left: 3rem;
      bottom: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: linear-gradient(to right, #13a0d8, #88d059);
      border-bottom-left-radius: 1rem;
      border-bottom-right-radius: 1rem;
      padding: 0.5rem;
      box-sizing: border-box;
      gap: 0.5rem;
      h5,
      p {
        color: white;
        margin: 0;
      }
    }
  }
}
.modal.show.right {
  .modal-dialog {
    min-height: 100%;
    background: linear-gradient(270deg, #c4fff7 -26.45%, #cde1ff 109.06%);
    .modal-content {
      min-height: 100%;
      background-color: transparent;
      border: none;
      .modal-header {
        display: flex;
        justify-content: flex-end;
        border: none;
        .close {
          border: 3px solid black;
          background-color: transparent;
          font-weight: 800;
          font-size: 30px;
          line-height: 20px;
          vertical-align: middle;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 0 3px 6px;
        }
      }
    }
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .team-members {
    .team-member-card {
      width: 33.33%;
    }
  }
  .modal.right {
    .modal-dialog {
      position: absolute;
      top: 0;
      right: 0;
      margin-top: 0;
      width: 450px;
    }
  }
}
</style>
